import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Intro Component
 * 
 * Exactly matches the legacy site's intro section
 */
const Intro = () => {
  return (
    <>
      <div className="intro">
        <h1 className="tk-name"><Link to="/">marc.tools</Link></h1>
        <p className="tagline">A Product R&D Toolkit</p>

        <div className="linkedin">
          <a href="https://www.linkedin.com/in/marchenrylee/"><i className="fab fa-linkedin fa-2x"></i></a>
        </div>
      </div>

      <div className="welcome">
        Welcome. I'm Marc and this is a Toolkit to create things.
      </div>

      <div className="linebreak"></div>
    </>
  );
};

export default Intro; 